import { useMemo } from 'react';
import { useAppContext } from '../../../app/Context';
import { CourseListItem } from '../../../db/courses/types';
import routes from '../../../routes/router';
import { toShortId } from '../../../utils/helper';

export interface UseNoClassesProps {
  selectedCourse: CourseListItem;
}

const useNoClasses = ({ selectedCourse }: UseNoClassesProps) => {
  const { session } = useAppContext();

  const timelineUrl = useMemo(() => {
    if (!session) return '';
    return routes.course.acadlyWebUrl({
      universitySlug: session.university.slug,
      courseId: toShortId(selectedCourse.courseId),
    });
  }, [session?.university.slug, selectedCourse.courseId]);

  const acadlyWebTimelineUrl = `${process.env.REACT_APP_ACADLY_WEB_URL}${timelineUrl}`;

  return { acadlyWebTimelineUrl };
};

export default useNoClasses;
